import { Box, styled } from "@mui/material";
import { Breadcrumb, SimpleCard } from "app/components";
import StoriesTable from "./StoriesTable";

const Container = styled("div")(({ theme }) => ({
    margin: "30px",
    [theme.breakpoints.down("sm")]: { margin: "16px" },
    "& .breadcrumb": {
        marginBottom: "30px",
        [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
    },
}));

const AllStories = () => {
    return (
        <Container>
            <Box className="breadcrumb">
                <Breadcrumb routeSegments={[{ name: "Dashboard", path: "" }, { name: "All Stories" }]} />
            </Box>

            <SimpleCard title="All Stories">
                <StoriesTable />
            </SimpleCard>
        </Container>
    );
};

export default AllStories;

